import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Lock, Building2, Users } from 'lucide-react';

interface ResendScopeDisplayProps {
  channelName?: string;
  companyName?: string;
  channelId?: number;
  companyId?: number;
}

/**
 * Componente para exibir canal e cliente pré-preenchidos em modo reenvio
 * Mostra informações de forma legível com ícones e badges
 */
export function ResendScopeDisplay({
  channelName,
  companyName,
  channelId,
  companyId,
}: ResendScopeDisplayProps) {
  return (
    <Card className="border-blue-200 bg-blue-50">
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-blue-900">
          <Lock className="w-4 h-4" />
          Escopo Fixo (Modo Reenvio)
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Canal */}
        <div className="flex items-center gap-3 p-3 bg-white rounded-lg border border-blue-100">
          <Building2 className="w-5 h-5 text-blue-600 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-600">Canal</p>
            <p className="text-base font-semibold text-gray-900 truncate">
              {channelName || `Canal #${channelId}`}
            </p>
          </div>
          <Badge variant="secondary" className="flex-shrink-0">
            ID: {channelId}
          </Badge>
        </div>

        {/* Cliente */}
        {companyId && (
          <div className="flex items-center gap-3 p-3 bg-white rounded-lg border border-blue-100">
            <Users className="w-5 h-5 text-blue-600 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-600">Cliente</p>
              <p className="text-base font-semibold text-gray-900 truncate">
                {companyName || `Cliente #${companyId}`}
              </p>
            </div>
            <Badge variant="secondary" className="flex-shrink-0">
              ID: {companyId}
            </Badge>
          </div>
        )}

        {/* Mensagem informativa */}
        <p className="text-sm text-blue-700 bg-blue-100 rounded p-2">
          Os valores acima estão bloqueados para manter a consistência com a importação original.
        </p>
      </CardContent>
    </Card>
  );
}
